import {useContext, useEffect, useMemo, useRef, useState} from "react";
import {FilterIcon} from "@heroicons/react/outline";
import FilterContext from "./../Context/FilterContext";
import RadiusesSelect from "./../Form/Select/RadiusesSelect";
import SpecialitySelect from "../Form/Select/SpecialitySelect";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

const SearchBar = () => {
    const {showFilters, setShowFilters, token, setLat, setLng, addressText, setAddressText, setUpdateFromGeocoder, setShowRestartSearch, setRadius, setSearchParams } = useContext(FilterContext)
    const handleClick = () => setShowFilters(!showFilters)

    const inputAddress = useRef()

    const onRadiusChange = item => {
        const { value } = item

        setRadius(value !== '*' ? value : undefined)

        setSearchParams(state => {
            state.set('radius', value)
            return state;
        }, { replace: true })
    }

    const geocoder = useMemo(() =>
        new MapboxGeocoder({
            accessToken: token,
            trackProximity: false,
            countries: 'fr,bl,gp,mf,mq,nc,pf,pm,re,tf,wf,ch,yt'
        }),
        []
    )

    useEffect(() => {
        geocoder.addTo(inputAddress.current)
        geocoder._inputEl.value = addressText
        geocoder.on('result', response => {

            // Bounding box for next updates
            /*if (response.result?.bbox !== undefined) {
                const invertedBbox = response.result.bbox
                setBbox([invertedBbox[1], invertedBbox[0], invertedBbox[3], invertedBbox[2]])
            }*/

            setAddressText(response.result?.place_name)
            setLng(response.result?.center[0])
            setLat(response.result?.center[1])
            setUpdateFromGeocoder(true)
            setShowRestartSearch(false)
        })
    }, [])

    useEffect(() => {
        geocoder._inputEl.value = addressText
    }, [addressText])

    return (
        <div className={"bg-white shadow-md md:h-20"}>
            <div className="h-full flex flex-wrap md:flex-nowrap md:items-center justify-center md:justify-between max-w-5xl mx-auto bg-white gap-2">
                <div className="flex flex-grow flex-col md:flex-row gap-4 md:items-center justify-between p-4">
                    <SpecialitySelect attribute="speciality" sortBy={['name_fr']} limit={100}/>
                    <div ref={inputAddress} className={'flex flex-grow'}></div>
                    <RadiusesSelect onChange={onRadiusChange} />
                    <button onClick={handleClick} className="flex px-4 py-2 gap-4 items-center rounded-lg shadow bg-teal-500 hover:bg-teal-600 hover:shadow-md transition truncate">
                        <FilterIcon className="h-4 w-4 text-white"/>
                        <p className="text-base text-center text-white">
                            Filtrer ma recherche
                        </p>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default SearchBar